import { VyFormSection, VyIcon, VyChip } from '@vy/ui-design-system';
import { useChargeContext } from '../../charge-context';
import { VySwitchField } from '../../../../../../design-system-adapters/forms';
import { FieldGrid } from '../../modify-panel-shared/layout';
import {
  UPLIFT_UNAVAILABLE_DESCRIPTION,
  useIsUpliftAvailable,
} from '../../modify-panel-shared/hooks/use-is-uplift-available';
import type { PlanInputForm } from '../../CreatePlanForm/create-plan-form-types/plan-input-form';

export function UpgradeOptionsSection() {
  const { itemIndex: productIndex } = useChargeContext();
  const isUpliftAvailable = useIsUpliftAvailable();

  return (
    <VyFormSection
      icon={<VyIcon icon="SectionUpgrade" width={20} height={20} />}
      title="Upgrade Options"
      action={<VyChip label="Growth" color="success" />}
    >
      <FieldGrid>
        <VySwitchField<PlanInputForm>
          name={`usageProducts.${productIndex}.upliftConfiguration.commitmentUpliftEnabled`}
          title="Commitment Ramp up"
          description={
            isUpliftAvailable
              ? 'Commitment amount / units step-up based on previous period usage'
              : UPLIFT_UNAVAILABLE_DESCRIPTION
          }
          disabled={!isUpliftAvailable}
          data-field-span="full"
          data-vy="usage-charge-drawer-commitment-ramp-switch"
        />
      </FieldGrid>
    </VyFormSection>
  );
}
